import { render, staticRenderFns } from "./sort-button.vue?vue&type=template&id=3015af96"
import script from "./sort-button.vue?vue&type=script&lang=js"
export * from "./sort-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports